const BASE = '/api/v1'

function authHeaders(): Record<string, string> {
  const stored = localStorage.getItem('cap-auth')
  if (stored) {
    try {
      const parsed = JSON.parse(stored) as { state?: { token?: string } }
      const tok = parsed.state?.token
      if (tok) return { Authorization: `Bearer ${tok}` }
    } catch { /* ignore */ }
  }
  return {}
}

export async function getVapidKey(): Promise<string> {
  const res = await fetch(`${BASE}/push/vapid-key`)
  if (!res.ok) throw new Error('Failed to fetch VAPID key')
  const data = await res.json() as { vapid_public_key: string }
  return data.vapid_public_key
}

export interface PushSubscriptionPayload {
  subscription: {
    endpoint: string
    expirationTime: number | null
    keys: { p256dh: string; auth: string }
  }
  min_priority: number
  hazard_types: string[] | null
  lat: number | null
  lon: number | null
}

export async function registerPushSubscription(body: PushSubscriptionPayload): Promise<string> {
  const res = await fetch(`${BASE}/subscriptions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error(`Subscribe failed: ${res.status}`)
  const data = await res.json() as { id: string }
  return data.id
}

export async function unregisterPushSubscription(id: string): Promise<void> {
  const res = await fetch(`${BASE}/subscriptions/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  })
  if (!res.ok && res.status !== 404) throw new Error(`Unsubscribe failed: ${res.status}`)
}
